
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/app/widgets/[widgetUuid]/experiences/[uuid]",
      function () {
        return require("private-next-pages/app/widgets/[widgetUuid]/experiences/[uuid]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/app/widgets/[widgetUuid]/experiences/[uuid]"])
      });
    }
  